import { useState } from 'react';
import cn from 'bem-cn';

import { ShareMethod } from '../../../utils/share';
import { Popover } from '../Popover';
import { Stack } from '../Stack';
import { Icon } from '../Icon';

import { SharesCounterProps } from './SharesCounter.types';
import './SharesCounter.scss';

const b = cn('shares');
const defaultDirection = 'row';

export const SharesCounter = (props: SharesCounterProps) => {
    const { shares, onClick, direction = defaultDirection } = props;
    const [popoverOpen, setPopoverOpen] = useState(false);
    const [disabled, setDisabled] = useState(false);

    const handleClick = async () => {
        setDisabled(true);

        try {
            const shareResult = await onClick();

            if (shareResult?.method === ShareMethod.Clipboard) {
                setPopoverOpen(true);
                setTimeout(() => {
                    setPopoverOpen(false);
                }, 2000);
            }
        } finally {
            setDisabled(false);
        }
    };

    const handleAfterClose = () => {
        setPopoverOpen(false);
    };

    return (
        <Popover
            open={popoverOpen}
            position="bottom"
            content="Скопировано"
            autoClose
            disabled
            afterClose={handleAfterClose}
        >
            <Stack
                as="button"
                disabled={disabled}
                onClick={handleClick}
                direction={direction}
                alignItems="center"
                justifyContent="center"
                className={b()}
                title="Поделились"
            >
                {Boolean(shares) && <span className={b('counter')}>{shares}</span>}
                <Icon className={b('icon')} name="share" />
            </Stack>
        </Popover>
    );
};
